<div class="counter">
    <p>99+</p>
</div>